export default __webpack_public_path__ + "media/images/images/gallery/39-9e6ec9dc50355d9436e7a00a494e6407.png";